import MuiButton from "@mui/material/Button";

const Button = (props) => {

    return <MuiButton {...props} disableElevation={true}/>
}

export default Button